// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JCa4kTGQzn2Hm0kX13Zv {
  width: 100%;
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/CenterContentWrapper/CenterContentWrapper.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".centerContentWrapper {\n  width: 100%;\n  background: var(--white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centerContentWrapper": `JCa4kTGQzn2Hm0kX13Zv`
};
export default ___CSS_LOADER_EXPORT___;
